BatchGeoStore.addReducer("MarkerLegend", function (state, action) {
  state = state || {
    isFiltered: false,
    filters: [],
    filteredMarkers: [],
    update: false,
    $listWrap: $(null),
    $list: $(null),
    $results: $(null),
  };

  /**
   * It will check if the given property is missing in the action and if so
   * will fall back to the existing state. This lets you passing only a subset
   * of action values without affecting the others.
   *
   * @param {string} prop A string of the action property to check for
   *
   * @example
   * case 'MARKER_LEGEND_CACHE_DOM':
   *	 return Object.assign({}, state, {
   *			$listWrap: optional('$listWrap'),
   *			$list: optional('$list'),
   *			$results: optional('$results')
   *		});
   *
   * @return {*} Will return either action.property or state.property of the
   * action property is undefined.
   */
  var optional = function (prop) {
    return action[prop] === undefined ? state[prop] : action[prop];
  };

  switch (action.type) {
    case "MARKER_LEGEND_SET_FILTERS":
      var groupedFilteredMarkers = action.filters.reduce(function (
        acc,
        filter,
      ) {
        var markerIds = Object.keys(filter.markers).map(function (id) {
          return parseInt(id);
        });
        acc[filter.column] = acc[filter.column]
          ? acc[filter.column].concat(markerIds)
          : markerIds;
        return acc;
      }, {});

      var filteredMarkersValues = Object.keys(groupedFilteredMarkers).map(
        function (column) {
          return groupedFilteredMarkers[column];
        },
      );

      return Object.assign({}, state, {
        isFiltered: Object.keys(action.filters).length > 0,
        filters: _.clone(action.filters),
        // Spread is used so we can give an array to be used as multiple
        // params. We want to pass something like [1, 2, 3] and have it
        // call _.intersection(1, 2, 3). _.spread does this for us.
        filteredMarkers: _.spread(_.intersection)(filteredMarkersValues).sort(),
        update: optional("update"),
      });
    case "MARKER_LEGEND_CLEAR_FILTERS":
      return Object.assign({}, state, {
        isFiltered: false,
        filters: [],
        filteredMarkers: [],
        update: optional("update"),
      });
    case "MARKER_LEGEND_RESET_UPDATE":
      return Object.assign({}, state, {
        update: false,
      });
    // Used to cache jQuery objects to DOM elements
    case "MARKER_LEGEND_CACHE_DOM":
      return Object.assign({}, state, {
        $listWrap: optional("$listWrap"),
        $list: optional("$list"),
        $results: optional("$results"),
      });
    default:
      return state;
  }
});
